import { Component } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import { connect } from "react-redux"
import classnames from "classnames"

import styles from "./platform_invoice.module.scss"

export class PlatformInvoiceList extends Component {
  constructor(props) {
    super(props)

    const stripeConfig = StripeCheckout.configure({
      key: props.stripeKey,
      "allow-remember-me": false,
      email: props.organization.owner.email,
      image: "/assets/partners/header/logo-ifttt.svg",
      locale: "auto",
      name: "IFTTT, Inc",
      description: "Platform Invoice",
    })

    this.state = {
      modalOpen: false,
      stripeConfig,
    }
  }

  renderStatus = invoice => {
    return invoice.status
  }

  render() {
    return (
      <>
        <header className="page-header">
          <h1>{this.props.orgName} Billing</h1>
        </header>

        <div className={classnames("invoice-description", styles["invoice-description"])}>
          <p>
            The {this.props.orgName} organization is subscribed to the Developer
            Plan for $199 USD, billed annually. If you’d like to change your
            plan to a different plan, please review your{" "}
            <a href={this.props.plansPath}>upgrade options</a>. View your past
            invoices below. Your plan will automatically renew each year for
            $199 USD. You may cancel your renewal at any time{" "}
            <a href="mailto:platform-support+billing@ifttt.com">via email</a>,
            however IFTTT does not offer refunds for past payments.
          </p>
        </div>

        {this.props.invoices.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th>Invoice date</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {this.props.invoices.map((invoice, index) => {
                return (
                  <tr key={index}>
                    <td>
                      {moment(
                        invoice.created_at,
                        "YYYY-MM-DD HH:mm:ss ZZZZ"
                      ).format("MMM DD, YYYY")}
                    </td>
                    <td>
                      $
                      {(invoice.invoice_total_in_cents * 0.01).toLocaleString(
                        "usd"
                      )}
                    </td>
                    <td>{this.renderStatus(invoice)}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        ) : (
          <div
            className={classnames("no-invoices-container", styles["no-invoices-container"])}
          >
            You have no outstanding invoices.
          </div>
        )}
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    orgName: state.details.orgName,
  }
}

export default connect(mapStateToProps)(PlatformInvoiceList)

PlatformInvoiceList.propTypes = {
  invoices: PropTypes.array,
  organization: PropTypes.object,
  orgName: PropTypes.string,
  plansPath: PropTypes.string,
  stripeKey: PropTypes.string,
}
